import { useEffect, useState } from 'react';
import BeheerPage from './pages/BeheerPage';
import JoinPage from './pages/JoinPage';
import MeetPage from './pages/MeetPage';
import MicTestPage from './pages/MicTestPage';
import VerslagPage from './pages/VerslagPage';

/**
 * Kleine eigen router. Vijf routes zijn geen bibliotheek waard:
 *   /          beheer: inloggen, en daarna kamers aanmaken
 *   /r/<id>    de kamer zelf
 *   /mic       microfoontest, om per toestel te meten wat werkt
 *   /meet      geluidsmeting voor iOS: microfoon en geluidssessie
 *   /verslag/<id>  gespreksverslag om als PDF op te slaan (gegevens achter de inlog)
 */
function leesPad(): { route: 'home' | 'kamer' | 'mic' | 'meet' | 'verslag'; kamerId: string } {
  if (/^\/mic\/?$/.test(window.location.pathname)) return { route: 'mic', kamerId: '' };
  if (/^\/meet\/?$/.test(window.location.pathname)) return { route: 'meet', kamerId: '' };
  const verslag = /^\/verslag\/([A-Za-z0-9_-]{32})\/?$/.exec(window.location.pathname);
  if (verslag?.[1] !== undefined) return { route: 'verslag', kamerId: verslag[1] };
  const treffer = /^\/r\/([A-Za-z0-9_-]{32})\/?$/.exec(window.location.pathname);
  return treffer?.[1] !== undefined
    ? { route: 'kamer', kamerId: treffer[1] }
    : { route: 'home', kamerId: '' };
}

export default function App() {
  const [pad, setPad] = useState(leesPad);

  useEffect(() => {
    // De terugknop van de browser moet gewoon werken.
    const opTerug = (): void => setPad(leesPad());
    window.addEventListener('popstate', opTerug);
    return () => window.removeEventListener('popstate', opTerug);
  }, []);

  if (pad.route === 'mic') return <MicTestPage />;
  if (pad.route === 'meet') return <MeetPage />;
  if (pad.route === 'verslag') return <VerslagPage kamerId={pad.kamerId} />;
  return pad.route === 'kamer' ? <JoinPage kamerId={pad.kamerId} /> : <BeheerPage />;
}
